export function toLocalDateInputValue(date = new Date()) {
  const dt = new Date(date);
  const year = dt.getFullYear();
  const month = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function addDaysToLocalDateInputValue(days = 0, baseDate = new Date()) {
  const dt = new Date(baseDate);
  dt.setDate(dt.getDate() + Number(days || 0));
  return toLocalDateInputValue(dt);
}

export function startOfYearLocalDateInputValue(baseDate = new Date()) {
  const dt = new Date(baseDate);
  return toLocalDateInputValue(new Date(dt.getFullYear(), 0, 1));
}
